import * as React from "react";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";

import createStyles from "@material-ui/core/styles/createStyles";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";

import { User as TUser } from "../../api";
import { genFullName } from "../../project-utils";
import { capitalize } from "../../utils";
import { ProfileAvatar } from "./index";

interface UserProps {
  user: TUser;
  onClick?: () => void;
}

const styles = createStyles({
  header: {
    cursor: "pointer",
  },
  root: {
    height: "100%",
  },
});

const UserCard = ({ user, onClick, classes }: UserProps & WithStyles<typeof styles>) => {
  const { personal, account } = user;

  let content;

  if (!account.active) {
    content = (
      <CardContent>
        <Typography>{account.email}</Typography>
      </CardContent>
    );
  } else {
    content = (
      <CardHeader
        className={classes.header}
        onClick={onClick}
        title={genFullName({ firstName: personal.name, surname: personal.surname })}
        subheader={account.email}
        avatar={<ProfileAvatar name={personal.name} img={personal.photo} surname={personal.surname} />}
      />
    );
  }

  return (
    <Card className={classes.root}>
      <CardHeader title={capitalize(String(user.account.type))} />
      <Divider />
      {content}
    </Card>
  );
};

export default withStyles(styles)(UserCard);



// WEBPACK FOOTER //
// ./src/components/molecules/UserCard.tsx